/**
 * Helpers for building profile URLs that support both aliases and UIDs.
 * If an entity has an alias set, the alias is used; otherwise the uid/id is used.
 */

/**
 * Returns the public URL path for a user's profile.
 * @param {Object} user - User object with optional alias, uid, and id fields.
 * @returns {string} URL path like "/usuario/juan-perez" or "/usuario/abc-123-uid"
 */
export const getUserProfilePath = (user) => {
  if (user?.alias) return `/usuario/${user.alias}`;
  return `/usuario/${user?.uid || user?.id}`;
};

/**
 * Returns the private/own profile URL path.
 * @param {Object} user - User object with optional alias, uid, and id fields.
 * @returns {string} URL path like "/perfil/juan-perez" or "/perfil/abc-123-uid"
 */
export const getPerfilPath = (user) => {
  if (user?.alias) return `/perfil/${user.alias}`;
  return `/perfil/${user?.uid || user?.id}`;
};

/**
 * Returns the public URL path for a company profile.
 * @param {Object} empresa - Company object with optional alias, uid, and id fields.
 * @returns {string} URL path like "/empresa/club-aura" or "/empresa/abc-123-uid"
 */
export const getEmpresaPath = (empresa) => {
  if (empresa?.alias) return `/empresa/${empresa.alias}`;
  return `/empresa/${empresa?.uid || empresa?.id}`;
};
